export const FeatureName = 'contactForm';
